import { env } from "@configs/env";
import { Link, useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import InputPasswordToggle from "@components/input-password-toggle";
import {
  Form,
  Input,
  Label,
  Card,
  Button,
  Spinner,
  CardText,
  CardBody,
  CardTitle,
} from "reactstrap";
import { useEffect, useState } from "react";
import "@styles/react/pages/page-authentication.scss";
import LogoNFTYDoor from "@src/assets/images/logo/logo-homebridge-dark.png";
import useAdmin from "../../utility/context/useAdminContext";
import { usePrivateLabel } from "@src/utility/context/privateLabelContetx";

const defaultValues = {
  password: "",
  loginEmail: "",
};

const Login = () => {
  const { privateLabel } = usePrivateLabel();
  const {
    singIn,
    loading,
    signInWithToken,
    admin,
    setAdmin,
    handleRefreshUser,
  } = useAdmin();
  const [environmentSelected, setEnviroment] = useState(
    localStorage.getItem("currentEnvironment") ?? "DEV"
  );
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ defaultValues });
  const [errorLogin, setErrorLogin] = useState();

  const { hash } = useLocation();

  const loadToken = async () => {
    const splitHash = hash.substring(1).split("&");
    if (splitHash.length === 4) {
      const token = {};
      splitHash.forEach((hashPart) => {
        const limiter = hashPart.indexOf("=");
        const attrName = hashPart.substring(0, limiter);
        const attrContent = hashPart.substring(limiter + 1);
        token[attrName] = attrContent;
      });
      const expiration =
        new Date().getTime() + parseInt(token?.expires_in) * 1000;
      localStorage.setItem("NFTdoorAdminToken", token.id_token);
      localStorage.setItem("NFTdoorAdminTokenExp", expiration);
      setAdmin({
        ...admin,
        token,
        exp: expiration,
      });
      admin.token = token;
      handleRefreshUser();
    }
  };

  useEffect(() => {
    loadToken();
    const splitHash = hash.substring(1).split("&");
    if (admin.permissions?.length > 1 && splitHash.length === 4) {
      signInWithToken(admin);
    }
  }, [hash, admin.permissions]);

  useEffect(() => {
    setErrorLogin(undefined);
  }, [watch("loginEmail"), watch("password")]);

  const onSubmit = async (data) => {
    const result = await singIn(data.loginEmail, data.password);
    setErrorLogin(result);
  };

  return (
    <div className="auth-wrapper auth-basic px-2">
      <div className="auth-inner my-2">
        <Card className="mb-0">
          <CardBody>
            <Link
              className="brand-logo"
              to="/"
              onClick={(e) => e.preventDefault()}
            >
              <img
                src={privateLabel ? privateLabel.logo : LogoNFTYDoor}
                style={{ objectFit: "contain" }}
                width={190}
                height={70}
              />
            </Link>
            <CardTitle tag="h4" className="mb-1">
              {privateLabel
                ? `Welcome to ${privateLabel?.lenderName} Admin`
                : "Welcome to NFTYDoor Admin"}
            </CardTitle>
            <CardText className="mb-2">Please sign-in</CardText>
            <Form
              className="auth-login-form mt-2"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="mb-1">
                <Label className="form-label" for="login-email">
                  Email
                </Label>
                <Controller
                  id="loginEmail"
                  name="loginEmail"
                  control={control}
                  render={({ field }) => (
                    <Input
                      autoFocus
                      type="email"
                      placeholder="john@example.com"
                      invalid={errors.loginEmail}
                      {...field}
                    />
                  )}
                />
              </div>
              <div className="mb-1">
                <div className="d-flex justify-content-between">
                  <Label className="form-label" for="login-password">
                    Password
                  </Label>
                </div>
                <Controller
                  id="password"
                  name="password"
                  control={control}
                  render={({ field }) => (
                    <InputPasswordToggle
                      className="input-group-merge"
                      invalid={errors.password}
                      {...field}
                    />
                  )}
                />
              </div>
              <div className="form-check mb-1">
                <Input type="checkbox" id="remember-me" />
                <Label className="form-check-label" for="remember-me">
                  Remember Me
                </Label>
              </div>
              {errorLogin && (
                <p className="color-danger text-center">{errorLogin}</p>
              )}
              <Button disabled={loading} color="primary" block>
                {loading ? (
                  <Spinner
                    style={{ width: 16, height: 16 }}
                    color="secondary"
                  />
                ) : (
                  "Login"
                )}
              </Button>
            </Form>
          </CardBody>
        </Card>
        {process.env.REACT_APP_ENV !== "prod" && (
          <select
            value={environmentSelected}
            onChange={(e) => {
              localStorage.setItem("currentEnvironment", e.target.value);
              setEnviroment(e.target.value);
              window.location.reload();
            }}
          >
            {Object.keys(env).map((items, index) => (
              <option key={index} value={items}>
                {items}
              </option>
            ))}
          </select>
        )}
      </div>
    </div>
  );
};

export default Login;
